import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { IMostAffectedCustomers } from "./models/most-affected-customers";
import { MostAffectedStateCustomersService } from "./services/widget-most-affected-customers.service";
import * as HSET from "./settings";
import { GenericUtils } from "./../../../utilities/generic-utils";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Params } from "@angular/router";
import { CommonService } from "../../../../shared/services";
@Component({
  selector: "app-widget-most-affected-customers",
  templateUrl: "./widget-most-affected-customers.component.html",
  styleUrls: ["./widget-most-affected-customers.component.scss"],
  providers: [MostAffectedStateCustomersService]
})
export class WidgetMostAffectedCustomersComponent implements OnInit, OnChanges, OnDestroy {
  @Input() TITLE: string;
  @Input() HEADINGS: string[] = [];
  @Input() FILTERS: object = {};
  @Input() OPTIONS: object;

  data = null;
  errorMessage = "";
  mockData = null;
  private unsubscribe: Subject<void> = new Subject();
  constructor(
    private mostAffectedService: MostAffectedStateCustomersService,
    private utils: GenericUtils,
    private commonService: CommonService,
    private activateRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS))
    this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
      if (Object.keys(params).length) {
        this.FILTERS = this.commonService.getFiltersParams(params, this.FILTERS);
        this.getMostAffectedCustomers();
      } else {
        this.FILTERS=JSON.parse(JSON.stringify(intiFilter));
        this.getMostAffectedCustomers();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      
    }
  }

  getMostAffectedCustomers() {
    const query = JSON.parse(JSON.stringify(this.FILTERS));
    query.limit = "7";
    this.data = null;
    this.mockData = null;
    this.errorMessage = "";
    this.mostAffectedService
      .getMostAffectedCustomers(this.OPTIONS, query)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        response => {
         if (response.data.length) {
            this.data = response.data;
            this.data.map(customer => {
              customer.value = this.utils.amountIndianUnit(customer.value);
              return customer;
            });
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockData = HSET.data;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockData = HSET.data;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
